import { ShieldCheck, MessageCircle, Mail, MapPin } from "lucide-react";
import { whatsappLink, COMPANY_NAME, WHATSAPP_NUMBER } from "@/lib/api";
import { CATEGORIES } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-[#0A1D36] text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center h-10 w-10 rounded-xl bg-white/10"><ShieldCheck className="h-5 w-5 text-emerald-400" /></span>
            <span className="font-heading font-extrabold text-white text-lg">Central <span className="text-emerald-400">MEI</span></span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Assessoria administrativa descomplicada para MEI, CPF e documentos de trânsito em todo o Brasil.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4">Serviços</h4>
          <ul className="space-y-2.5 text-sm">
            {Object.values(CATEGORIES).map((c) => (
              <li key={c.label}><a href="#servicos" className="hover:text-emerald-400 transition-colors">{c.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4">Institucional</h4>
          <ul className="space-y-2.5 text-sm">
            <li><a href="#como-funciona" className="hover:text-emerald-400 transition-colors">Como Funciona</a></li>
            <li><a href="#depoimentos" className="hover:text-emerald-400 transition-colors">Depoimentos</a></li>
            <li><a href="#faq" className="hover:text-emerald-400 transition-colors">Perguntas Frequentes</a></li>
            <li><a href="/admin/login" className="hover:text-emerald-400 transition-colors">Área do Administrador</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white mb-4">Contato</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={whatsappLink(`Olá! Preciso de ajuda com os serviços da ${COMPANY_NAME}.`)} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-emerald-400"><MessageCircle className="h-4 w-4 text-emerald-400" /> (21) 98348-3905</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-emerald-400" /> contato@centralmei.com.br</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-emerald-400" /> Rio de Janeiro, RJ</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <p className="text-xs text-slate-400 leading-relaxed">
            <strong className="text-slate-300">Aviso Legal:</strong> Somos uma empresa privada de assessoria e consultoria administrativa.
            Não possuímos vínculo direto com órgãos governamentais (Receita Federal, Governo Federal ou DETRAN).
            Os serviços fornecidos são de intermediação e facilitação burocrática. Os serviços governamentais também podem ser realizados gratuitamente nos canais oficiais.
          </p>
          <p className="text-xs text-slate-500 mt-4">© {new Date().getFullYear()} {COMPANY_NAME}. Todos os direitos reservados. · Dados protegidos (LGPD) · Conexão segura SSL.</p>
        </div>
      </div>
    </footer>
  );
}
